<template>
  <adminTable
    :hideResetButton="true"
    :tableLoading="tableLoading"
    :totalList="totalList"
    v-model:page="page"
    v-model:limit="limit"
    v-model:searchForm="searchForm"
    v-model:selectedIds="selectedIds"
    :tableData="tableData"
    @search="getList"
  >
    <template v-slot:form-inline-items>
      <el-form-item>
        <el-input v-model="searchForm.phone" placeholder="请输入手机号码" clearable />
      </el-form-item>
      <el-form-item>
        <el-select v-model="searchForm.status" placeholder="处理状态" clearable>
          <el-option v-for="item in transferStatusEnums" :label="item.label" :value="item.value" />
        </el-select>
      </el-form-item>
    </template>
    <template v-slot:query-button-right>
      <el-button type="primary" @click="multipleHandle(0)" :disabled="selectedIds.length < 1" v-permission>一键同意</el-button>
      <el-button type="danger" @click="multipleHandle(2)" :disabled="selectedIds.length < 1" v-permission>一键拒绝</el-button>
    </template>
    <template v-slot:table>
      <el-table-column type="selection" :selectable="(row) => row.status == 1" width="55" />
      <el-table-column prop="id" label="ID" width="60" />、
      <el-table-column prop="order_no" label="订单号" width="200" />
      <el-table-column prop="from_uid" label="转账人ID" width="100" />
      <!-- <el-table-column prop="username" label="转账人" width="160">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.from_phone }}
          </span>
        </template>
      </el-table-column> -->
      <el-table-column prop="from_phone" label="转账人手机号" width="120">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.from_phone }}
          </span>
        </template>
      </el-table-column>
      <!-- <el-table-column prop="is_test" label="用户类型" width="130">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ getLabelByVal(scope.row.is_test, accountTypeEnums) }}
          </span>
        </template>
      </el-table-column> -->
      <el-table-column prop="to_uid" label="接收人ID" width="100" />
      <!-- <el-table-column prop="to_username" label="接收人" width="200">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.to_username }}
          </span>
        </template>
      </el-table-column> -->
      <el-table-column prop="to_phone" label="接收人手机号" width="120">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.to_phone }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="amount" label="金额" width="120">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.amount }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="status" label="状态" width="120">
        <template #default="scope">
          <el-tag :type="scope.row.status == 0 ? 'success' : scope.row.status == 2 ? 'danger' : 'primary'">
            {{ getLabelByVal(scope.row.status, transferStatusEnums) }}</el-tag
          >
        </template>
      </el-table-column>
      <el-table-column prop="create_at" label="创建时间" width="160">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.create_at }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="update_at" label="更新时间" width="160">
        <template #default="scope">
          <span :style="{ color: scope.row.is_test == 1 ? 'red' : '' }">
            {{ scope.row.update_at }}
          </span>
        </template>
      </el-table-column>
      <el-table-column fixed="right" v-if="currentUser.role == 0" prop="address" width="200" label="操作">
        <template #default="scope">
          <div class="table-handle-td">
            <el-button type="primary" v-permission @click="multipleHandle(0, [scope.row.id])" :disabled="scope.row.status != 1">通过</el-button>
            <el-button type="danger" v-permission @click="multipleHandle(2, [scope.row.id])" :disabled="scope.row.status != 1">拒绝</el-button>
          </div>
        </template>
      </el-table-column>
    </template>
  </adminTable>
</template>

<script setup>
  import { ref, getCurrentInstance, onMounted } from 'vue'
  import { transferStatusEnums, getLabelByVal, accountTypeEnums } from '../../config/enums'
  import { useRoute } from 'vue-router'
  import { ElMessage, ElMessageBox } from 'element-plus'

  const route = useRoute()

  const currentUser = JSON.parse(sessionStorage.getItem('currentUser'))
  const searchForm = ref({
    phone: '',
    status: '',
  })

  onMounted(() => {
    if (route.query && route.query.phone) {
      searchForm.value.phone = route.query.phone
    }
    getList()
  })

  const { proxy } = getCurrentInstance()

  const selectedIds = ref([])
  const multipleHandle = (type, ids = []) => {
    if (ids.length > 0) {
      selectedIds.value = ids
    }
    if (selectedIds.value == 0) {
      ElMessage({
        type: 'error',
        message: '请选择需要操作的列表',
      })
      return
    }
    ElMessageBox.prompt(`请输入${selectedIds.value.length > 1 ? '批量' : ''}${type == 0 ? '通过' : '拒绝'}理由`, '提示', {
      confirmButtonText: '提交',
      cancelButtonText: '取消',
    })
      .then(async ({ value }) => {
        const res = await proxy.$http({
          method: 'post',
          url: 'money/auditMemberTransfer',
          data: {
            ids: selectedIds.value.join(','),
            status: type,
            remark: value,
          },
        })
        if (res.code == 0) {
          ElMessage({
            type: 'success',
            message: `${selectedIds.value.length > 1 ? '批量' : ''}${type == 0 ? '通过' : '拒绝'}成功，${type == 0 ? '通过' : '拒绝'}理由是${value}`,
          })
          getList()
        } else {
          ElMessage({
            type: 'error',
            message: res.msg,
          })
        }
      })
      .catch(() => {
        ElMessage({
          type: 'info',
          message: '取消操作！',
        })
      })
  }

  const page = ref(1)
  const limit = ref(10)
  const totalList = ref(0)
  const tableLoading = ref(false)
  const tableData = ref([])
  const getList = async () => {
    tableLoading.value = true
    const res = await proxy.$http({
      type: 'get',
      url: '/money/getMemberTransferAuditList',
      params: {
        ...searchForm.value,
        page: page.value,
        limit: limit.value,
      },
    })
    tableLoading.value = false
    if (res.code == 0) {
      tableData.value = res.data.data
      totalList.value = res.data.total
    }
  }
</script>

<style lang="less" scoped></style>
